@let value = valueSg();

<div class="atn-ds-table-cell-value-boolean">
  @if (value === true) {
    <i class="atn-icon atn-check-circle"></i>
  } @else if (value === false) {
    <i class="atn-icon atn-close-circle"></i>
  }
</div>
